module.exports = __webpack_public_path__ + "img/four1Orange.48731de8.png";